export default __webpack_public_path__ + "static/media/BrainBreak cards42.5f5a4fe0.png";